import { useForm } from 'react-hook-form';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, Select, Textarea } from 'components/FormComponents';

export const AddNoteModal = ({
  visible,
  title = 'Add note',
  maxLength = 255,
  onSubmit = () => {},
  onClose = () => {},
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <AnimatedModal visible={visible} onClose={onClose} title={title}>
      <form style={{ width: '400px' }} className="u-margin-top" onSubmit={handleSubmit(onSubmit)}>
        <Textarea
          register={register}
          name="message"
          validators={{ required: true }}
          error={errors?.message?.type}
          placeholder="Enter note..."
          inputProps={{ rows: 5, maxLength }}
        />
        <Button className="u-width-100 u-margin-top" submit>
          Add Note
        </Button>
      </form>
    </AnimatedModal>
  );
};
